export const metaMixin = {
	data() {
		return {
			event_types: [],
		
		}
	},
	methods:{

		load_meta_data() {
			let self = this; // make sure we can access this inside of our promisses
			this.errormsg = '';

			axios
				.get("/api/leave/meta", {
				})
				.then(function(d) {
					let json = d.data;

					// For some reason axios isn't always converting our data
					if ((typeof json) == "string") {
						json = JSON.parse(json);
					}


					if (json.status == "OK") {
						

						// get leave types
						
						self.event_types = json.data.event_types;
						self.event_types.sort(function(a,b) { return a.desc > b.desc });


						
					} else {
						self.errormsg = json.reason;
					}
				})
				.catch(function(e) {
					console.log(e);
					self.errormsg = e.message;
				});
		},
		eventtype_desc(id) {
			for (let i = 0; i < this.event_types.length; i++) {
				if (this.event_types[i].id == id) {
					return this.event_types[i].desc
				}
			}

			return "???"
		},

	}
}
